import { useFreeSignupInfo } from '../useFreeSignupInfo';
import { useUpdateFreeSignupMutation } from '../useUpdateFreeSignupMutation';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { CONFIGURE_FREE_SIGNUP_STORAGE_KEY } from 'src/modules/product/components/freeSignupModal/constants';
import { LocalStorageHelper } from 'src/shared/helpers/localStorage';
export function useActiveFreeSignup(isFreeModule) {
    const { user } = useHostContext();
    const { offerId, isFreeSignupAllowed } = useFreeSignupInfo(isFreeModule);
    const updateFreeSignupMutation = useUpdateFreeSignupMutation();
    const isFreeSignupModalDismissed = LocalStorageHelper.getItem(CONFIGURE_FREE_SIGNUP_STORAGE_KEY) === 'true';
    const shouldActivateFreeSignup = isFreeModule && isFreeSignupAllowed === false && offerId && !user.isAttendant;
    function activeFreeSignup() {
        if (shouldActivateFreeSignup) {
            const payload = {
                allowSignup: true,
                description: '',
                imageId: null,
                mediaId: null,
                mediaVideoUrl: null,
                mediaVideoProvider: null,
                offers: [{ offerKey: offerId }]
            };
            updateFreeSignupMutation.mutate(payload);
        }
    }
    return {
        activeFreeSignup,
        shouldActivateFreeSignup,
        isFreeSignupModalDismissed
    };
}
